
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members/account/transaction-history",
      function () {
        return require("private-next-pages/members/account/transaction-history/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members/account/transaction-history"])
      });
    }
  